import { render } from "./Scaricamento.vue?vue&type=template&id=506b8dd9&scoped=true"
import script from "./Scaricamento.vue?vue&type=script&lang=js"
export * from "./Scaricamento.vue?vue&type=script&lang=js"

import "./Scaricamento.vue?vue&type=style&index=0&id=506b8dd9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506b8dd9"]])

export default __exports__